import Ows from "../utils/OwsHandler";
import { setUser } from "../auth/user-slice";
import { AppDispatch } from "../store";

export const logout = async (dispatch: AppDispatch): Promise<void> => {
  try {
    await Ows.logout();
    dispatch(setUser(null));
  } catch (error) {
    console.error("Logout failed:", error);
  }
};